<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Ketentuan Leader Board</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div class="section mt-3 mb-3">
                <div class="section-heading">
                    <h2 class="title">Rewards</h2>
                </div>
                <ul class="listview image-listview inset m-0">
                    <li v-for="(item, index) in rewards" :key="index">
                        <div class="item">
                            <img
                                :src="require('@/assets/medal_1.png')"
                                alt="image"
                                class="image"
                                v-if="index == 0"
                            />
                            <img
                                :src="require('@/assets/medal_2.png')"
                                alt="image"
                                class="image"
                                v-else-if="index == 1"
                            />
                            <img
                                :src="require('@/assets/medal_3.png')"
                                alt="image"
                                class="image"
                                v-else-if="index == 2"
                            />
                            <div class="icon-box bg-light" v-else>
                                <b>{{ index + 1 }}</b>
                            </div>
                            <div class="in">
                                <div>
                                    <b
                                        >Bonus
                                        {{ item.points | rupiah }} points</b
                                    >
                                </div>
                                <div class="text-muted text-right">
                                    <small>Setara dengan</small><br />
                                    <b class="text-primary"
                                        >Rp {{ item.rupiah | rupiah }}</b
                                    >
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="section mt-3 mb-3">
                <div class="section-heading">
                    <h2 class="title">Ketentuan</h2>
                </div>
                <div
                    class="padding"
                    style="
                        line-height: 17px;
                        font-size: 12px;
                        text-align: justify;
                    "
                >
                    <ol>
                        <li>Program Leader Board berlaku setiap bulan.</li>
                        <li>
                            Periode Program dimulai awal bulan s.d akhir bulan
                            di bulan berjalan.
                        </li>
                        <li>
                            Program leader board dapat berubah-ubah setiap
                            bulannya.
                        </li>
                        <li>
                            Program ini hanya dapat diikuti oleh Mitra yang
                            sudah melakukan upgrade ke Agen Affiliate Plus.
                        </li>
                        <li>
                            Agen Affiliate Plus akan otomatis ikut serta dalam
                            program ini selama memenuhi ketentuan yang berlaku.
                        </li>
                        <li>
                            Program ini tidak berlaku bagi karyawan
                            {{ VUE_ENV.VUE_APP_NAME }}
                            beserta keluarga, pihak agensi (influencer) dan
                            pihak ketiga lainnya yang ikut membantu program ini.
                        </li>
                        <li>
                            Total Downline yang dihitung adalah total downline
                            yang sudah terverifikasi dan sudah melakukan
                            pengisian saldo untuk bertransaksi.
                        </li>
                        <!-- <li>
                            Terdapat minimal downline yang aktif akan dihitung
                            masuk pada leader board dengan rincian sebagai
                            berikut :
                            <ul>
                                <li>Klasmen 1 : Minimal > 10 Downline Aktif</li>
                                <li>Klasmen 2 : Minimal > 7 Downline Aktif</li>
                                <li>Klasmen 3 : Minimal > 5 Downline Aktif</li>
                            </ul>
                        </li> -->
                        <li>
                            Total Transaksi yang dihitung adalah total transaksi
                            dari downline yang akunnya sudah terverifikasi.
                        </li>
                        <li>
                            Rewards yang diberikan dalam bentuk points yang
                            dapat ditukarkan pada menu points.
                        </li>
                        <li>
                            Jumlah Points yang diberikan setiap bulannya akan
                            berbeda-beda menyesuaikan dengan program yang
                            berjalan.
                        </li>
                        <li>
                            Bonus points akan diberikan maksimal ditanggal 5
                            bulan berikutnya.
                        </li>
                        <li>
                            Pihak penyelenggara sepenuhnya berhak untuk
                            membatalkan, memperpendek, memperpanjang maupun
                            menunda periode program jika dalam keadaan memaksa
                            (Force Majeure)
                        </li>
                        <li>
                            Pihak penyelenggara akan menindak tegas pihak-pihak
                            yang melakukan kecurangan pada program ini.
                        </li>
                        <li>
                            Keputusan Tim {{ VUE_ENV.VUE_APP_NAME }} ada mutlak
                            dan tidak dapat diganggu gugat.
                        </li>
                    </ol>
                </div>
            </div>
            <div class="section inset mt-2">
                <div class="section-heading">
                    <h2 class="title">FAQ</h2>
                </div>

                <div class="accordion" id="faq">
                    <div class="item" v-for="item in faq" :key="item.posisi">
                        <div class="accordion-header">
                            <button
                                class="btn text-left collapsed"
                                type="button"
                                data-toggle="collapse"
                                :data-target="'#faq_' + item.posisi"
                            >
                                <b>{{ item.question }}</b>
                            </button>
                        </div>
                        <div
                            :id="'faq_' + item.posisi"
                            class="accordion-body collapse"
                            data-parent="#faq"
                        >
                            <div class="accordion-content">
                                {{ item.answer }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    // import $axios from '../../../api.js';
    import { mapActions, mapState } from 'vuex';
    export default {
        data() {
            return {
                loadingApp: true,
                faq: [
                    {
                        posisi: 1,
                        question: 'Siapa saja yang bisa ikut program ini?',
                        answer: 'Program ini dapat diikuti oleh seluruh mitra yang sudah melakukan upgrade menjadi Agen Affiliate Plus.',
                    },
                    {
                        posisi: 2,
                        question:
                            'Apakah perlu mendaftarkan diri untuk mengikuti program ini?',
                        answer: 'Tidak ada pendaftara untuk mengikuti program ini, cukup dengan upgrade mnejadi Agen Affiliate Plus maka otomatis Mitra otomatis akan ikut serta dalam program ini.',
                    },
                    {
                        posisi: 3,
                        question:
                            'Apakah ada minimal downline yang harus di ajak setiap bulan?',
                        answer: 'Tidak ada, saat kamu memiliki downline dibulan program berjalan, maka akan langsung terhitung selama downline tersebut memenuhi ketentuan yang berlaku.',
                    },
                    {
                        posisi: 4,
                        question:
                            'Peringkat berapa saja yang mendapatkan rewards?',
                        answer: 'Rewards diberikan pada peringkat 1, 2 dan 3 sesuai dengan ketentuan rewards.',
                    },
                    {
                        posisi: 5,
                        question:
                            'Kapan rewards baru diberikan kepada pemenang?',
                        answer: 'Rewards akan diberikan maksimal ditanggal 5 bulan selanjutnya dalam bentuk points.',
                    },
                    {
                        posisi: 6,
                        question:
                            'Apakah downline yang saya ajak harus verifikasi akun?',
                        answer: 'Tidak, downline yang Mitra ajak tidak di wajibkan untuk melakukan verifikasi akun.',
                    },
                ],
                rewards: [
                    {
                        position: 1,
                        points: 20000,
                        rupiah: 100000,
                    },
                    {
                        position: 2,
                        points: 15000,
                        rupiah: 75000,
                    },
                    {
                        position: 1,
                        points: 10000,
                        rupiah: 50000,
                    },
                ],
            };
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
        },
        methods: {
            ...mapActions(['getCustomer', 'getSetting']),
        },
        mounted() {
            this.loadingApp = false;
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
